import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateBankStatementsMutation = (
	creditReviewId: string,
	refetchBankStatementsInfo: Function,
) => {
	const dispatch = useDispatch();

	return useMutation(
		({
			formValues,
		}: {
			formValues: { [key: string]: any };
			setActionFormState: Function;
		}) => {
			const model = formValues?.bankStatements
				?.filter(item => item?.month?.name)
				?.map(item => ({
					month: item?.month?.name,
					beginning: item?.beginning || undefined,
					credits: item?.credits || undefined,
					debits: item?.debits || undefined,
					ending: item?.ending || undefined,
					average: item?.average || undefined,
				}));

			return creditReviewDetailsService.updateBankStatementsInfo(
				creditReviewId,
				model,
			);
		},
		{
			onSuccess(_result, { setActionFormState }) {
				refetchBankStatementsInfo();
				setActionFormState(false);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateBankStatementsMutation;
